"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortFlyersFactory = exports.flyerSort = exports.isGradeInRange = exports.MAX_RANGE = exports.HIGHEST_GRADE_ORD = exports.LOWEST_GRADE_ORD = exports.DISTRICT_TYPES = exports.SCHOOL_TYPES = exports.ORG_TYPES = exports.OwnerType = void 0;
var GradeLevels_1 = require("./GradeLevels");
var OwnerType;
(function (OwnerType) {
    OwnerType["School"] = "school-staff";
    OwnerType["DistrictStaff"] = "district-staff";
    OwnerType["District"] = "district";
    OwnerType["Volunteer"] = "volunteer";
    OwnerType["Unknown"] = "unknown";
    OwnerType["OrgMember"] = "org-member";
    OwnerType["Org"] = "organization";
    OwnerType["CommFree"] = "commfree";
})(OwnerType = exports.OwnerType || (exports.OwnerType = {}));
exports.ORG_TYPES = [OwnerType.Org, OwnerType.OrgMember, OwnerType.CommFree];
exports.SCHOOL_TYPES = [OwnerType.School];
exports.DISTRICT_TYPES = [OwnerType.District, OwnerType.DistrictStaff, OwnerType.Volunteer, OwnerType.Unknown];
exports.LOWEST_GRADE_ORD = GradeLevels_1.toOrdinal(GradeLevels_1.GradeLevels.Prekindergarten);
exports.HIGHEST_GRADE_ORD = GradeLevels_1.toOrdinal(GradeLevels_1.GradeLevels.NotGraded);
exports.MAX_RANGE = exports.HIGHEST_GRADE_ORD - exports.LOWEST_GRADE_ORD;
function sortBySubmitDate(aSubDate, bSubDate) {
    if (aSubDate > bSubDate)
        return -1;
    if (aSubDate < bSubDate)
        return 1;
    return 0;
}
function isGradeInRange(minTarget, maxTarget, grade) {
    return grade <= maxTarget && grade >= minTarget;
}
exports.isGradeInRange = isGradeInRange;
function getOrdinals(flyer, isSod) {
    var min = flyer.minTargetGrade, max = flyer.maxTargetGrade;
    var minOrdinal = exports.LOWEST_GRADE_ORD;
    var maxOrdinal = exports.HIGHEST_GRADE_ORD;
    if (min)
        minOrdinal = GradeLevels_1.toOrdinal(min);
    if (max)
        maxOrdinal = GradeLevels_1.toOrdinal(max);
    if (min && isSod && !max) {
        maxOrdinal = minOrdinal;
    }
    if (max && isSod && !min) {
        minOrdinal = maxOrdinal;
    }
    return [minOrdinal, maxOrdinal];
}
// For each child grade, give it a score that reflects its distance from target endpoints.
// Use the best (smallest) to compare in the main sort.
function gradeRangeScores(minTarget, maxTarget, grades) {
    var scores = [];
    var range = Math.abs(maxTarget - minTarget);
    grades.forEach(function (g) {
        var childGrade = GradeLevels_1.toOrdinal(g);
        if (g === GradeLevels_1.GradeLevels.NotGraded || (childGrade <= maxTarget && childGrade >= minTarget)) {
            // child grade is in range, score is just range
            scores.push(range);
        }
        else { // child's grade is out of target range. Calculate distance out of range
            scores.push(exports.MAX_RANGE + Math.min(Math.abs(childGrade - minTarget), Math.abs(childGrade - maxTarget)));
        }
    });
    return scores.length ? scores.sort(function (a, b) { return a - b; })[0] : exports.MAX_RANGE + range;
}
// Sort flyers according to the following rules:
// 1. Schools before districts before orgs
// 2. Narrower target ranges before wider ones
// 3. If childGrade is outside the range, SoDs exclude and Orgs prioritize by distance from the range
// 4. Everything else equal, order newer ones first
//
// Additionally, when only one min/max target is omitted, SoDs treat the the given min/max as the sole target grade,
// but Orgs treat the missing bound as the upper/lower limit. E.g. if maxTargetGrade is set to 10 and minTargetGrade is null,
// the effective range is 1-10
function flyerSort(childGrades) {
    var fn = function (a, b) {
        var _a = a.generic, aType = _a.ownerType, aSubDate = _a.submittedAt;
        var _b = b.generic, bType = _b.ownerType, bSubDate = _b.submittedAt;
        var aIsOrg = exports.ORG_TYPES.includes(aType);
        var aIsSchool = exports.SCHOOL_TYPES.includes(aType);
        var aIsDistrict = exports.DISTRICT_TYPES.includes(aType);
        var aIsSod = aIsSchool || aIsDistrict;
        var bIsOrg = exports.ORG_TYPES.includes(bType);
        var bIsSchool = exports.SCHOOL_TYPES.includes(bType);
        var bIsDistrict = exports.DISTRICT_TYPES.includes(bType);
        var bIsSod = bIsSchool || bIsDistrict;
        // 1. SoDs before orgs
        if (aIsSod && bIsOrg)
            return -1;
        if (bIsSod && aIsOrg)
            return 1;
        var _c = __read(getOrdinals(a.generic, aIsSod), 2), aMinOrdinal = _c[0], aMaxOrdinal = _c[1];
        var _d = __read(getOrdinals(b.generic, bIsSod), 2), bMinOrdinal = _d[0], bMaxOrdinal = _d[1];
        // both flyers created by SoDs
        if (aIsSod && bIsSod) {
            var aRange = Math.abs(aMaxOrdinal - aMinOrdinal);
            var bRange = Math.abs(bMaxOrdinal - bMinOrdinal);
            if (aRange === bRange) {
                if (aIsSchool && bIsDistrict) {
                    return -1;
                }
                if (bIsSchool && aIsDistrict) {
                    return 1;
                }
                return sortBySubmitDate(aSubDate, bSubDate);
            }
            return aRange - bRange;
        }
        var aSortGrade = gradeRangeScores(aMinOrdinal, aMaxOrdinal, childGrades);
        var bSortGrade = gradeRangeScores(bMinOrdinal, bMaxOrdinal, childGrades);
        if (aSortGrade !== bSortGrade)
            return aSortGrade - bSortGrade;
        return sortBySubmitDate(aSubDate, bSubDate);
    };
    return fn;
}
exports.flyerSort = flyerSort;
function sortFlyersFactory(flyerMapper, compareFactory) {
    if (compareFactory === void 0) { compareFactory = flyerSort; }
    return function (flyers, childGrades) {
        var sortableFlyers = flyers.map(function (f) { return ({
            original: f,
            generic: flyerMapper(f),
        }); });
        var filteredFlyers = sortableFlyers.filter(function (f) {
            var ownerType = f.generic.ownerType;
            var isOrg = exports.ORG_TYPES.includes(ownerType);
            if (isOrg)
                return true;
            var _a = __read(getOrdinals(f.generic, isOrg), 2), minOrdinal = _a[0], maxOrdinal = _a[1];
            // ordinal 16 is unknown or unrecognizable, don't filter
            return childGrades.some(function (g) { return GradeLevels_1.toOrdinal(g) === 16 || isGradeInRange(minOrdinal, maxOrdinal, GradeLevels_1.toOrdinal(g)); });
        });
        filteredFlyers.sort(compareFactory(childGrades));
        var result = filteredFlyers.map(function (f) { return f.original; });
        return result;
    };
}
exports.sortFlyersFactory = sortFlyersFactory;
// Example usage:
// import { PendingFlyerEmail } from './api/PendingFlyerEmail'
// import { sortFlyersFactory } from './lib/flyerSort'
//
// const sortFlyers = sortFlyersFactory<PendingFlyerEmail>()
// const myFlyers: PendingFlyerEmail[] = []
// const myGrades: GradeLevels[] = []
// const myMapper: GenericFlyerMapper<PendingFlyerEmail> = (f => ({ id: f.flyerId }))
//
// const sortedFlyers = sortFlyers(myFlyers, myGrades, myMapper)
// Example usage from parent webapp:
// import { sortFlyersFactory } from '@peachjar/flyer-email-builder/dist/lib/flyerSort'
// interface ParentWebappFlyer { }
// const myMapper: GenericFlyerMapper<PendingFlyerEmail> = (f => ({ id: f.flyer_id }))
// const myFlyers: ParentWebappFlyer[] = []
//
// const sortFlyers = sortFlyersFactory<ParentWebappFlyer>(myFlyers, myGrades, myMapper)
//# sourceMappingURL=SortFlyers.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/flyer-email-builder/dist/api/SortFlyers.js
// module id = 3135
// module chunks = 0